let env = location.host.indexOf("localhost") > -1 ? "local" : location.host.indexOf("dev-usermanagement.blfdev.lab") > -1 ? "dev" : location.host.indexOf("qa-usermanagement.blfdev.lab") > -1 ? "qa" : location.host.indexOf("stg-usermanagement.blfdev.lab") > -1 ? "stg" : "prod";

const enviromentVariable = {
    uri: env == "local" ? "https://localhost:44310/" : env == "dev" ? "https://dev-usermanagement.blfdev.lab/" : env == "qa" ? "https://qa-usermanagement.blfdev.lab/" : env == "stg" ? "https://stg-usermanagement.blfdev.lab/" : "https://usermanagement.niceincontact.com/",
    authority: env == "local" ? "https://dev-icids.ucn.net/identity" : env == "dev" ? "https://dev-icids.ucn.net/identity" : (env == "qa" || env == "qatemp") ? "https://qa-icids.ucn.net/identity" : env == "stg" ? "https://stg-icids.ucn.net/identity" : "https://icids.ucn.net/identity",
    clientId: env == "local" ? "UserManagementLocalhost" : "UserManagement",
    manageUserNotificationUrl: "",
    customerCommunityUrl: "",    
    perPage: 20,
    tokenExpireMessage: "Your session has expired, and, will be refreshed.",
    noticeToEndUserStartingDate: "",
    isInvalidDateForNotice: ""

}

export default enviromentVariable;